import { useNavigate, useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetRoomEditPageParams = () => {
	const { hotelID, roomID } = useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DEFAULT>>();

	const navigate = useNavigate();
	if (!(hotelID && roomID)) {
		navigate("/");
	}

	return {
		hotelID: hotelID!,
		roomID: roomID!,
	};
};
